import { StorageAdapter } from "@/domains/storage/StorageAdapter";

export class LocalStorageDriver<T> implements StorageAdapter<T> {
  constructor(private readonly key: string) {}

  load(): T | null {
    try {
      const raw = localStorage.getItem(this.key);
      if (!raw) return null;
      return JSON.parse(raw) as T;
    } catch (e) {
      console.error("[LocalStorageDriver] Failed to load key:", this.key, e);
      return null;
    }
  }

  save(data: T): void {
    try {
      localStorage.setItem(this.key, JSON.stringify(data));
    } catch (e) {
      console.error("[LocalStorageDriver] Failed to save key:", this.key, e);
    }
  }

  clear(): void {
    try {
      localStorage.removeItem(this.key);
    } catch (e) {
      console.error("[LocalStorageDriver] Failed to clear key:", this.key, e);
    }
  }
}
